import type { Transition, Variants } from "framer-motion";

export const IOS_EASE_BEZIER: [number, number, number, number] = [
  0.32, 0.72, 0, 1
];
export const IOS_EASE = `cubic-bezier(${IOS_EASE_BEZIER.join(", ")})`;
export const CARD_MODAL_BREAKPOINT = "(max-width: 767px)";

const ENTER_DURATION_S = 0.4;
const EXIT_DURATION_S = 0.4;
const RECEDE_DURATION_S = 0.4;

/** Falls back to 30px when the device reports no safe-area-inset-top. */
const RECEDED_TOP_OFFSET = "max(env(safe-area-inset-top, 30px), 30px)";

const MODAL_PEEK_PX = 20;
const MODAL_PEEK = `${MODAL_PEEK_PX}px`;
const RECEDE_SCALE = 0.93;

export const CARD_MODAL_TOP_INSET = `calc(${RECEDED_TOP_OFFSET} + ${MODAL_PEEK})`;
export const CARD_MODAL_RADIUS = "14px";
export const IOS_BACKDROP_OPACITY = 0.32;

export const APP_RECEDE_TRANSFORM = `scale(${RECEDE_SCALE}) translateY(${RECEDED_TOP_OFFSET})`;

export const RECEDE_TRANSITION = `transform ${RECEDE_DURATION_S * 1000}ms ${IOS_EASE}, border-radius ${RECEDE_DURATION_S * 1000}ms ${IOS_EASE}`;

export const overlayVariants: Variants = {
  closed: { opacity: 0 },
  open: { opacity: 1 }
};

/** `receded` is applied on mobile when this panel is not the topmost. */
export const panelVariants: Variants = {
  closed: { y: "100%", scale: 1 },
  open: { y: 0, scale: 1 },
  receded: { y: -MODAL_PEEK_PX, scale: RECEDE_SCALE }
};

export const enterTransition: Transition = {
  duration: ENTER_DURATION_S,
  ease: IOS_EASE_BEZIER
};

export const exitTransition: Transition = {
  duration: EXIT_DURATION_S,
  ease: IOS_EASE_BEZIER
};

export const recedeTransition: Transition = {
  duration: RECEDE_DURATION_S,
  ease: IOS_EASE_BEZIER
};

export const REDUCED_MOTION_TRANSITION: Transition = { duration: 0.001 };
